import { Max, Scale, Subtract, Total } from "@pdfking/math"

import { PALETTE } from "#constants"
import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { PlannerWeek } from "../PlannerWeek"
import { PocketMonths } from "../PocketMonths"
import { Region } from "../Region"

/** Lexicon, a perpetual desk planner: under a rule in the primary its week
 * undated, Monday to Saturday a column each, Sunday under Saturday; under it
 * lines for notes, the year's months small and the contact, over a band of
 * picture with the year on it at its foot. */
export const Lexicon: CalendarDesign = {
  cover: PictureCover({}),
  page: ({ gap, labels, language, outer, page, short, year }) => {
    const pitch = Scale(short, 0.03)
    const picture = Region(page, 0, 0, 1, 0.12)
    const above = Slice.over(outer, Total(picture.y, picture.height), gap)
    const [lower, upper] = Slice.bottom(above, Scale(above.height, 0.3), gap)
    const [rule, week] = Slice.top(upper, Scale(pitch, 0.15))
    const [notes, rest] = Slice.left(lower, Scale(lower.width, 0.3), gap)
    const [contact, months] = Slice.right(rest, Scale(lower.width, 0.3), gap)
    const [title, lines] = Slice.top(notes, pitch)
    // The year mid band, within the security frame
    const caption = Scale(picture.height, 0.45)
    const caption_y = Total(picture.y, Scale(Subtract(picture.height, caption), 0.5))
    return [
      Area.titled(
        picture,
        "year",
        { ...outer, height: caption, y: Max(caption_y, outer.y) },
        `${year}`
      ),
      Area.solid(rule),
      ...PlannerWeek(week, year, undefined, pitch, Scale(short, 0.02), language),
      Area.text({ ...title, height: Scale(pitch, 0.7) }, labels.NOTES(), PALETTE.primary),
      Area.rules(lines, pitch),
      ...PocketMonths(months, year, 4),
      Area.contact(Slice.top(contact, Scale(short, 0.08))[0], false),
    ]
  },
  pages: "pad",
}
